// extracted by mini-css-extract-plugin
export default {"customRow":"styles_customRow__fVsLA","customHeaderCell":"styles_customHeaderCell__KxPrO"};